import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  loader: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    aspectRatio: '16/9',
    pointerEvents: 'none',
    backgroundColor: 'var(--primary__page__background) !important',
    position: 'relative'
  },
  badge: {
    flex: 1,
    fontFamily: 'BentonSansBold',
    fontSize: '14px !important',
    height: '22px !important',
    paddingTop: '6px !important',
    margin: '20px 0px 0px 15px !important',
    width: 'min-content',
    textAlign: 'center'
  },
  card: {
    borderBottomLeftRadius: '0 !important',
    backgroundColor: 'var(--primary__page__background) !important'
  },
  cardBody: {
    backgroundColor: 'var(--primary__page__background) !important'
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between !important'
  },
  carousel: ({ hasMultipleActions }) => ({
    '&:after': {
      content: "' '",
      display: !hasMultipleActions && 'none',
      minWidth: '20px'
    },
    padding: '5px 35px 35px 15px'
  }),
  map: {
    paddingBottom: '10px',
    marginBottom: '5px'
  },
  subheader: {
    display: 'flex',
    flexDirection: 'row !important',
    justifyContent: 'flex-start !important'
  },
  title: {
    fontWeight: '600 !important',
    textDecoration: ({ variant }) => variant === 'invalid' && 'line-through'
  },
  '@media (max-width: 667px)': {
    cardBody: {
      padding: '6px 16px !important'
    }
  }
})

export default useStyles
